module.exports = __webpack_public_path__ + "static/img/旅游.22a61d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/旅游.png
// module id = BzjT
// module chunks = 3